<template>
  <div class="pt-1 pb-4 px-4">
    <button class="inline-flex items-center gap-1.5 px-4 py-2 text-sm text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-primary hover:border-primary transition-colors mb-4 min-h-[44px]" @click="$emit('back')">
      <span>←</span> Back to Products
    </button>

    <h3 class="text-xl font-bold text-gray-800 mb-4">Get Quotation - {{ product.name }}</h3>

    <div class="border rounded-lg overflow-hidden mb-4">
      <div class="grid grid-cols-3 bg-gray-100 text-xs font-medium text-gray-600">
        <div class="p-2">Product Picture</div>
        <div class="p-2">Product Name</div>
        <div class="p-2">Quantity</div>
      </div>
      <div class="grid grid-cols-3 items-center border-t">
        <div class="p-2">
          <img v-if="activePhoto" :src="activePhoto" :alt="product.name" class="w-16 h-16 object-cover rounded">
        </div>
        <div class="p-2 text-sm text-gray-800">{{ product.name }}</div>
        <div class="p-2">
          <input type="number" v-model.number="localQuantity" min="1" class="w-full border border-gray-300 rounded px-2 py-1 text-sm">
        </div>
      </div>
    </div>

    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
        <input type="text" v-model="localFormData.name" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[44px]">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1"><span class="text-red-500">*</span> Email</label>
        <input type="email" v-model="localFormData.email" placeholder="We will send quotation to this email" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[44px]">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1"><span class="text-red-500">*</span> Phone No.</label>
        <input type="tel" v-model="localFormData.phone" placeholder="We will discuss details over WhatsApp" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[44px]">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Company</label>
        <input type="text" v-model="localFormData.company" placeholder="Company or Business Name" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[44px]">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Message</label>
        <textarea v-model="localFormData.message" rows="3" placeholder="Please tell us your needs" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"></textarea>
      </div>
      <button class="w-full py-3 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors text-lg min-h-[44px]" @click="submit">Submit Inquiry</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InquiryForm',
  props: {
    product: {
      type: Object,
      required: true
    },
    activePhoto: {
      type: String,
      default: ''
    },
    quantity: {
      type: Number,
      default: 1
    },
    formData: {
      type: Object,
      required: true
    }
  },
  computed: {
    localQuantity: {
      get() {
        return this.quantity;
      },
      set(value) {
        this.$emit('update:quantity', value);
      }
    },
    localFormData: {
      get() {
        return this.formData;
      },
      set(value) {
        this.$emit('update:formData', value);
      }
    }
  },
  methods: {
    submit() {
      this.$emit('submit', {
        productId: this.product.id,
        productName: this.product.name,
        quantity: this.localQuantity,
        ...this.localFormData
      });
    }
  }
}
</script>

<style scoped>
</style>
